import {atom} from 'recoil';

interface LegalEntity {
    id: string;
    name: string;
}

interface Dealer {
    id: string;
    name: string;
    legalEntity: LegalEntity;
}

interface Department {
    id: string;
    name: string;
}

interface Profile {
    id: string;
    name: string;
}

interface Auth {
    id: string;
    name: string;
}

interface ProfileDetailStructure {
    legalEntityDtos: LegalEntity[];
    dealerDtos: Dealer[];
    departmentDtos: Department[];
    profileDtos: Profile[];
    authDtos: Auth[];
}

const defaultList: any[] = [];
export const profileList = atom({
    key: 'profileList',
    default: defaultList
});

export const profileDetailStructure = atom({
    key: 'profileDetailStructure',
    default: {
        legalEntityDtos: [],
        dealerDtos: [],
        departmentDtos: [],
        profileDtos: [],
        authDtos: [],
    } as ProfileDetailStructure
});
